import { useLocation } from 'react-router'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { BroadcastsRoutes } from 'entities/ExportRouters'

const vuiToReact: { [key: string]: string } = {
  '/recurring': `/${BroadcastsRoutes.root}`,
  '/ringless': `/${BroadcastsRoutes.root}/${BroadcastsRoutes.ringless}`,
}

export function useRedirectRouter() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    if (pathname) {
      const reactRoute = vuiToReact[pathname]
      if (reactRoute) {
        navigate(reactRoute)
      }
    }
  }, [pathname])
}
